import type {ReactElement} from 'react';
import {ImagePartsLightbox} from '@Components/ai-chat-window/components/image-parts-lightbox/image-parts-lightbox';
import type {ImagePart} from '@Components/ai-chat-window/ai-chat-window.types';
import {ChatMessagePartType} from '@Components/ai-chat-window/ai-chat-window.types';
import {noop} from '@Utils/general.util';
import type {AiChatAssetsImagePreviewProps} from './ai-chat-assets-image-preview.types';
import {IMAGE_PREVIEW_INDEX, IMAGE_PREVIEW_NO_MESSAGES} from './ai-chat-assets-image-preview.types';

export function AiChatAssetsImagePreview({asset, onClose}: AiChatAssetsImagePreviewProps): ReactElement {
  const imagePart: ImagePart = {
    type: ChatMessagePartType.MODEL_GENERATED_IMAGE,
    hashedId: asset.assetHashedFilename,
    width: asset.width,
    height: asset.height,
    hasLayeredPoster: false,
  };

  return (
    <ImagePartsLightbox
      chatId={asset.idAiChat}
      messageId={asset.messageId ?? undefined}
      imageParts={[imagePart]}
      isLightboxOpen
      currentImageIndex={IMAGE_PREVIEW_INDEX}
      handleCloseLightbox={onClose}
      handlePreviousImage={noop}
      handleNextImage={noop}
      messages={IMAGE_PREVIEW_NO_MESSAGES}
      canWrite
      onReattach={noop}
    />
  );
}
